import { Box, Button, Grid, Typography } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";

const LegalFooter: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Box mb={2} mt={2}>
      <Grid container spacing={2}>
        <Grid item>
          <Button
            data-testid="footerPrivacyLink"
            href="https://www.warhammer.com/legal#Privacy%20Notice"
            style={{ textDecoration: "underline", fontWeight: 400 }}
            variant="text"
            target="_blank"
            rel="noopener"
          >
            {t("footer.privacyPolicy")}
          </Button>
        </Grid>
        <Grid item>
          <Button
            data-testid="manageCookies"
            href="https://www.warhammer.com/legal#Cookie%20Notice"
            style={{ textDecoration: "underline", fontWeight: 400 }}
            variant="text"
            target="_blank"
            rel="noopener"
          >
            {t("footer.cookiePolicy")}
          </Button>
        </Grid>
        <Grid item>
          <Button
            id="ot-sdk-btn"
            data-testid="cookieSettings"
            style={{
              all: "inherit",
              textDecoration: "underline",
              fontWeight: 400,
              cursor: "pointer",
            }}
            variant="text"
            className="ot-sdk-show-settings"
          >
            {t("footer.cookieSettings")}
          </Button>
        </Grid>
      </Grid>
      <Box mb={2} mt={2} paddingLeft={1}>
        <Typography variant="caption" data-testid="copyrightNotice">
          {t("footer.copyrightNotice", { year: new Date().getFullYear() })}
        </Typography>
      </Box>
    </Box>
  );
};
export default LegalFooter;
